import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'ba-reset-link-expired',
  template: `
    <mat-card class="main-container">
      <mat-card-header>
        <mat-card-title class="header-logo">
          <img src="/assets/images/logo.png" alt="biome-logo" />
        </mat-card-title>
        <mat-card-title class="header-title">
          <h3 class="title">Reset Link Expired</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <br />
        <div>
          <span>
            This password reset link is invalid or has expired. Please request a
            new one.
          </span>
        </div>
        <br />
        <button
          mat-raised-button
          color="primary"
          data-ba-id="requestNewLink"
          routerLink="/forgot-credentials"
        >
          Request New Link
        </button>
        <div class="info-box">
          If you need further assistance, please reach out to
          <a href="mailto:support@biome.io">support&#64;biome.io</a>.
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styleUrls: ['./reset-link-expired.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCardModule, MatIconModule, RouterLink, MatButtonModule],
})
export class ResetLinkExpiredComponent {}
